import httpManager from "@/app/shared/utils/httpManager";

/**
 * Creates manually a contact.
 *
 * @param {number} contactData Contact data with the portfolioId.
 */
export async function updateContact(contactData, idCliente) {
  await httpManager.put(`/contacts/clients/${idCliente}/`, contactData);
}
